module.exports = __webpack_public_path__ + "img/curve-2-1.70863702.svg";